import { Button, Modal } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { addUser, getUsersList } from "../../../core/data/redux/usersSlice";
import { DateFormat } from "../../../core/hooks/dateFormat";
import { all_routes } from "../../router/all_routes";
import PermissionGuard from "../../permissionGuard";
import { isSupportViewer } from "../../../utils/permissionUtils";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Preloader from "../../../core/common/loader/preLoader";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const schema = Yup.object().shape({
  username: Yup.string().required(),
  //password: Yup.string().required(),
  email: Yup.string().required(),
  phone: Yup.string().required(),
  dob: Yup.string().required(),
  first_name: Yup.string().required('First Name is required'),
  last_name: Yup.string().required('Last Name is required'),
});


const AdminUsersList = () => {
  const routes = all_routes;
  const dispatch = useDispatch();
  const usersState = useSelector((state: any) => state.usersState);

  const [dataList, setDataList] = useState<any[]>([]);
  const [query, setQuery] = useState<string>("");
  const [modal, setModal] = useState<{ show: boolean; data: any }>({
    show: false,
    data: null,
  });
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 10,
  });


  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      username: "",
      //password: "",
      email: "",
      phone: "",
      dob: "",
      first_name: "",
      last_name: "",
    },
  });


  const handleAdd = () => {
    reset();
    setModal({ show: true, data: null });
  };



  const fetchRecords = (pagination: any, query: string) => {
    dispatch(
      getUsersList({
        page: pagination.current,
        limit: pagination.pageSize,
        query,
      })
    );
  };

  const handlePagination = (pagination: any) => {
    setPagination({
      current: pagination.page,
      pageSize: pagination.pageSize,
      total: pagination.total || 10,
    });
    fetchRecords(pagination, query);
  };

  const handleSearch = (query: string) => {
    fetchRecords(pagination, query);
  };

  useEffect(() => {
    fetchRecords(pagination, query);
  }, []);

  useEffect(() => {
    if (usersState.loading === "fulfilled" && usersState.action == 'list') {

      setDataList(usersState.users?.data?.data || []);
      setPagination((prev) => ({
        ...prev,
        total: usersState.users?.data?.total || 0,
        current: usersState.users?.data?.page || 1,
        pageSize: usersState.users?.data?.limit || 10,
      }));
    }else if (usersState.loading === "fulfilled" && usersState.action == 'save') {
      setModal({ show: false, data: null });
      toast.success(usersState?.users?.message)
    }
    else if (usersState.loading === "rejected") {
      console.log('usersState',usersState)
      toast.error(usersState?.error);
    }

    
  }, [usersState.loading]);


  

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "id",
      render: (text: string, record: any, index: number) => (
        <>
          <div>
            {pagination.current
              ? index + pagination.current * pagination.pageSize - pagination.pageSize + 1
              : index + 1}
          </div>
        </>
      ),
      sorter: (a: any, b: any) => a.id - b.id,
    },
    {
      title: "First Name",
      dataIndex: "first_name",
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: "Username",
      dataIndex: "username",
      render: (text: any) => <span>{text}</span>,
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (text: any) => <span>{text}</span>,
    },
    {
      title: "Birth Date",
      dataIndex: "dob",
      render: (text: any) => DateFormat(text, "DD-MM-YYYY") || "",
    },
    {
      title: "Role",
      dataIndex: "role",
      render: (text: any) => <span>{text}</span>,
    },
    // {
    //   title: "Verified",
    //   dataIndex: "verified",
    //   render: (text: any) => <span>{text ? "Yes" : "No"}</span>,
    // },
    {
      title: "Created At",
      dataIndex: "created_at",
      render: (text: any) => DateFormat(text) || "",
    },
    {
      title: "Modified At",
      dataIndex: "modified_at",
      render: (text: any) => DateFormat(text) || "",
    },
    ...(!isSupportViewer()
      ? [
          {
            title: "Actions",
            dataIndex: "actions",
            render: (text: string, record: any, index: number) => (
              <div className="action-icon d-inline-flex">
                <Link
                  to="#"
                  className="me-2"
                  onClick={() => {
                    setModal({ show: true, data: record });
                    setValue("username", record.username);
                    setValue("email", record.email);
                    setValue("phone", record.phone);
                    setValue("dob", record.dob);
                    setValue("first_name", record.first_name);
                    setValue("last_name", record.last_name);
                  }}
                >
                  <i className="ti ti-edit" />
                </Link>
              </div>
            ),
          },
        ]
      : []),
  ];

  const onSubmit = async (data: any) => {
    if (modal.data) {
      // Add the ID for edit operation
      data['id'] = modal.data.id;
    }
    
    dispatch(addUser(data))
      .unwrap()
      .then(() => {
        setModal({ show: false, data: null });
        reset();
        fetchRecords(pagination, query);
      })
      .catch((error: any) => {
        
        
      });
  }
  return (
    <>
      {(usersState.loading === "pending" && usersState.action == 'save') && <Preloader />}
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Admin Users</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Administration</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Admin Users
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <PermissionGuard route="admin-users/add">
                <button type="button" className="btn btn-primary w-100" onClick={handleAdd}>
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add Admin User
                </button>
              </PermissionGuard>
              <Modal
                title={modal.data ? "Edit Admin User" : "Add Admin User"}
                destroyOnHidden
                open={modal.show}
                onCancel={() => setModal({ show: false, data: null })}
                footer={null}
                width={800}
              >

                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="modal-body mb-3">
                    <div className="row">
                      {/* First Name */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">First Name</label>
                          <input
                            type="text"
                            className="form-control"
                            {...register("first_name")}
                          />
                          {errors.first_name && (
                            <small className="text-danger">{errors.first_name.message}</small>
                          )}
                        </div>
                      </div>

                      {/* Last Name */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Last Name</label>
                          <input
                            type="text"
                            className="form-control"
                            {...register("last_name")}
                          />
                          {errors.last_name && (
                            <small className="text-danger">{errors.last_name.message}</small>
                          )}
                        </div>
                      </div>

                      {/* Username */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Username</label>
                          <input
                            type="text"
                            className="form-control"
                            {...register("username")}
                          />
                          {errors.username && (
                            <small className="text-danger">{errors.username.message}</small>
                          )}
                        </div>
                      </div>

                      {/* Password */}
                      {/* <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Password</label>
                        <input
                          type="password"
                          className="form-control"
                          {...register("password")}
                        />
                        {errors.password && (
                          <small className="text-danger">{errors.password.message}</small>
                        )}
                      </div>
                    </div> */}

                      {/* Email */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Email</label>
                          <input
                            type="email"
                            className="form-control"
                            {...register("email")}
                          />
                          {errors.email && (
                            <small className="text-danger">{errors.email.message}</small>
                          )}
                        </div>
                      </div>

                      {/* Phone */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Phone</label>
                          <input
                            type="text"
                            className="form-control"
                            {...register("phone")}
                          />
                          {errors.phone && (
                            <small className="text-danger">{errors.phone.message}</small>
                          )}
                        </div>
                      </div>

                      {/* Date of Birth */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Date of Birth</label>
                          <input
                            type="date"
                            className="form-control"
                            {...register("dob")}
                          />
                          {errors.dob && (
                            <small className="text-danger">{errors.dob.message}</small>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button type="submit" className="btn btn-primary">Submit</button>
                  </div>
                </form>


              </Modal>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-4 mt-3">Admin Users</h4>
            </div>
            <div className="card-body p-0 py-3">
              <Table
                columns={columns}
                dataSource={dataList}
                Selection={false}
                paginationConfig={pagination}
                handlePagination={handlePagination}
                loading={(usersState.loading && usersState.action == 'list') === "pending"}
                handleSearch={handleSearch}
              />
            </div>
          </div>
        </div>
      </div>
    </>

  );
};

export default AdminUsersList;
